import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { Subject } from 'rxjs';
import { AlertService } from '../../_services/alert.service';
import { saveAs } from 'file-saver';
import { ExcelServiceService } from '../../_models/excel-service.service';
import * as moment from 'moment';
import { unitOfTime } from 'moment';

//import {NgbModal} from @ng-bootstrap/ng-bootstrap;
@Component({
  selector: 'app-warehouse-request-list',
  templateUrl: './warehouse-request-list.component.html',
  styleUrls: ['./warehouse-request-list.component.css']
})

export class WarehouseRequestListComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  notificationPopup: string = "#saveModal";
  approvePopup: string = "#approveModal";
  step: number = 1;
  warehouseRequest: any = [];
  approveDismissModal: string = "modal";
  notifyDismissModal: string = "modal";
  distinctCities: any;
  warehousesList: any;
  viewCustomer: any;
  addresses: any;
  warehouse: any;
  shipmentsList: any = [];
  tabClicked: string = "all";
  city: any;
  statusText: string;
  approvalStatus: string;
  autoRenewFlag: boolean;
  duration: any;
  cost: any;
  discount: any;
  finalCost: any;
  status: string;
  accountOwnerId: string;
  durationType: string;
  unitsRequested: string;
  warehouseSelected: any;
  warehouseId: string;
  warehouseRequestId: string;
  selectedWarehouse: any;
  warehouseForDelete: any;
  message: any;
  notificationTypes: any = [];
  endDate: any;
  charge: string;
  charges: any = [];
  startDate: any;
  notification: any;
  warehouseData: any = [];
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  addressText: string;
  statusMessage: string = "";
  errorMessage: string;
  warehouseDetailsErrorMessage: string;
  warehouseDetails: string;
  false: boolean;
  masterSelected: boolean = false;
  checkedList = [];
  previousStatus = '';
  warehouseStatus: any = 'ALL';
  totalRecords: number;
  costPerMonth: number = 0;
  userDrop2: any = 'ALL';

  constructor(private route: ActivatedRoute, private alertService: AlertService, private excelService: ExcelServiceService, private http: HttpClient, private router: Router, private api: ApiIntegration, private g: Globals, public user: User) {
    this.g.page = "Account Requests";
    this.populateTabData('all', "ALL");
  }

  populate(orderChange) {
    this.api.getWarehouseRequestsByApprovalStatus("1", orderChange, "ACCOUNT_OWNER").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.warehouseRequest = data.getWarehouseRequestData;
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }

  notifyConfirm() {
    this.step = 2;
    this.api.getValues("1", 'WAREHOUSE', 'NOTIFY', 'Notification Type').subscribe((data: any) => {
      this.notificationTypes = data.tripleSetConfigDTOS;
    }, err => {
      console.log(err);
    });
  }

  checkWarehouse(warehouseRequest) {
    let i = 0;
    let ohid = {};
    for (let warehousePopUp of warehouseRequest) {
      if (warehousePopUp.isSelected) {
        i = i + 1;
        ohid = warehousePopUp;
      }
    }
    ;
    if (i === 1) {
      this.selectedWarehouseRequest(ohid);
    } else {
      this.errorMessage = "Can not Edit multiple Shipments at once. Please select one at a time";
    }
  }


  shipMultipleOrders(warehouseRequest) {
    let i = 0;
    let ohid;
    for (let order of warehouseRequest) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order.accountOwnerId;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/adminVerifyDocuments/' + ohid]);
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }

  exportToXLSX() {
    this.excelService.exportAsExcelFile(this.warehouseRequest, 'sample');
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(true);
    });
  }

  populateTabData(triggered, warehouseStatus) {
    this.tabClicked = triggered;
    this.warehouseStatus = warehouseStatus;
    if (!this.previousStatus) {
      this.getNotifyByStatus(warehouseStatus);
    } else {
      this.rerender();
    }

  }

  getNotifyByStatus(status) {
    this.dtOptions = {
      "ordering": false,
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      language: {
        searchPlaceholder: 'Search by Company Name/Email/Mobile'
      },
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.warehouseStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.warehouseStatus;
        }
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        let apiMethod = 'api/warehouseRequestsByApprovalStatusAndOrgIdAndAccountOwnerId';
        let query: any = {
          approvalStatus: this.warehouseStatus,
          organizationId: 1,
          accountType: "ACCOUNT_OWNER",
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        this.g.loaderDisplay = "display";
        this.http.get(environment.apiUrl + apiMethod, { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.warehouseRequest = resp.getWarehouseRequestData;
            this.totalRecords = resp.noOfRecords;
            this.g.loaderDisplay = "";
            this.warehouseRequest.forEach((s) => {
              s['isSelected'] = false;
            });
            callback({
              recordsTotal: resp.noOfRecords,
              recordsFiltered: resp.noOfRecords
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    };
  }

  getNotificationMessage() {
    this.message = this.notification.description;
    this.rerender();
  }

  selectedWarehouseRequest(w) {
    this.selectedWarehouse = w;
    this.step = 1;
    this.g.loaderDisplay = "display";
    this.api.getAccountOwner(w.accountOwnerId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.viewCustomer = data;
      this.addresses = this.viewCustomer.adddressList;
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }

  tabChange() {
    this.checkedList = [];
    this.errorMessage = "";
    this.g.loaderDisplay = "display";
  }

  submitApprove() {
    this.approvePopup = "#approveModal";
    this.approveDismissModal = "modal";
    if (this.selectedWarehouse == null) {
      this.statusText1 = ' Something went wrong, please re-try';
      this.approveDismissModal = "";
      this.approvePopup = "#";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/approvedWarehouseRequests', {
      "accountOwnerId": this.selectedWarehouse.accountOwnerId,
      "approvalStatus": "APPROVED",
      "organizationId": 1,
      "warehouseRequestId": this.selectedWarehouse.warehouseReqId
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        if (data['code'] == 200) {
          this.alertService.success('Account', 'Approved Successfully');
          let index = this.warehouseRequest.indexOf(this.selectedWarehouse);
          this.warehouseRequest.splice(index, 1);
          this.selectedWarehouse = null;
          this.rerender();
        } else {
          this.alertService.error('Error', 'Account information submission failed. Please re-try.');
          this.approveDismissModal = "";
          this.approvePopup = "#";
        }
      },
        (err: HttpErrorResponse) => {
          this.alertService.error('Error', 'Exception: Account information submission failed. Please re-try.');
          this.approveDismissModal = "";
          this.approvePopup = "#";
        });
  }

  submitNotify() {
    this.notifyDismissModal = "modal";
    this.notificationPopup = "#saveModal";
    this.statusText6 = "";

    if (this.statusText6 != "") {
      this.notificationPopup = "#";
      this.notifyDismissModal = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/approvedWarehouseRequests', {
      "accountOwnerId": this.selectedWarehouse.accountOwnerId,
      "approvalStatus": "NOTIFIED",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        if (data['code'] == 200) {
          let index = this.warehouseRequest.indexOf(this.selectedWarehouse);
          this.warehouseRequest.splice(index, 1);
          this.alertService.success('Account', 'Notified Successfully');
          this.rerender();
        } else {
          this.alertService.error('Error', 'Account information submission failed. Please re-try.');
          this.notifyDismissModal = "";
          this.notificationPopup = "#";
        }
      },
        (err: HttpErrorResponse) => {
          this.alertService.error('Error', 'Exception: Account information submission failed. Please re-try.');
          this.notifyDismissModal = "";
          this.notificationPopup = "#";
        });
  }

  checkUncheckAll() {
    this.checkedList = [];
    for (var i = 0; i < this.warehouseRequest.length; i++) {
      this.warehouseRequest[i].isSelected = this.masterSelected;
    }
    this.getCheckedShipList();
  }

  selectShip(sl) {
    if (!sl.isSelected) {
      this.masterSelected = false
    }
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.checkedList = [];
    for (var i = 0; i < this.warehouseRequest.length; i++) {
      if (this.warehouseRequest[i].isSelected) {
        this.checkedList.push(this.warehouseRequest[i]['warehouseReqId']);
      }
    }
  }
}
